import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCMe8FcfNurLtz1I_TYCP3CtgxgJER0mIU",
  authDomain: "driver-app-75489.firebaseapp.com",
  projectId: "driver-app-75489",
  storageBucket: "driver-app-75489.appspot.com",
  messagingSenderId: "439888307567",
  appId: "1:439888307567:web:5ed211f2e5104a4ba0f49a",
  measurementId: "G-7E16ELEKFW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);

function logAnalyticsEvent(event) {
  if (event && typeof event == "string") logEvent(analytics, event);
}

export { logAnalyticsEvent };
